import ExperimentDtoClient from 'business/models/ExperimentDtoClient';
import { CustomLayerDTO, LayerTypeDTO } from 'business/models/Models';
import { getIngredient } from 'business/plateviewer/Generate/GenerateCommon';
import { getIngIngType, getIngredientStock, getIngredientType } from 'utils/Global';
import { TABLE_LAYOUT } from './ExperimentReportPDF';

export function customLayerDetailSubReport(content: any[], expData: ExperimentDtoClient) {
  const customLayers = expData.layers.filter(
    (lyr) => lyr.type === LayerTypeDTO.ConditionList,
  );
  customLayers.forEach((layer) => {
    const lyrDetail = layer.layerDetail as CustomLayerDTO;
    content.push({
      text:
        '\n' + layer.name + ' - ' + (layer.height + 1) + ' x ' + (layer.width + 1) + '\n',
      style: 'largeText',
    });
    content.push(getCustomLayerDetailTable(lyrDetail));
  });
}

function getCustomLayerDetailTable(lyrDetail: CustomLayerDTO) {
  const body: any = [
    [
      { text: 'Condition #', bold: true },
      { text: 'Type', bold: true },
      { text: 'Ingredient Name', bold: true },
      { text: 'Stock Conc.', bold: true },
      { text: 'Stock Low pH', bold: true },
      { text: 'Stock High pH', bold: true },
      { text: 'Conc', bold: true },
      { text: 'pH', bold: true },
    ],
  ];
  lyrDetail.condition.forEach((condtion) => {
    condtion.conditionIngredient.forEach((ing) => {
      const ingIngType = getIngIngType(ing.ingredientIngredientTypeId);
      const ingType = getIngredientType(ingIngType.ingredientTypeId);
      const ingredient = getIngredient(ingIngType.ingredientId);
      const ingStock = getIngredientStock(ing.ingredientStockId);
      const highPhIngStock = getIngredientStock(ing.highPhingredientStockId);
      body.push([
        {
          text: condtion.conditionNumber,
          style: condtion.conditionNumber % 2 == 1 ? 'tableAltRow' : '',
        },
        {
          text: ingType.name,
          style: condtion.conditionNumber % 2 == 1 ? 'tableAltRow' : '',
        },
        {
          text: ingredient.longName,
          style: condtion.conditionNumber % 2 == 1 ? 'tableAltRow' : '',
        },
        {
          text: ingStock.stockConcentration,
          style: condtion.conditionNumber % 2 == 1 ? 'tableAltRow' : '',
        },
        {
          text: ingStock.isBuffer ? ingStock.stockPh : '',
          style: condtion.conditionNumber % 2 == 1 ? 'tableAltRow' : '',
        },
        {
          text: ingStock.isBuffer && highPhIngStock ? highPhIngStock.stockPh : '',
          style: condtion.conditionNumber % 2 == 1 ? 'tableAltRow' : '',
        },
        {
          text: ing.concentration,
          style: condtion.conditionNumber % 2 == 1 ? 'tableAltRow' : '',
        },
        {
          text: ing.pH ? ing.pH : '',
          style: condtion.conditionNumber % 2 == 1 ? 'tableAltRow' : '',
        },
      ]);
    });
  });

  return {
    table: {
      widths: ['10%', '15%', '30%', '10%', '12%', '13%', '5%', '5%'],
      headerRows: 1,
      body: body,
    },
    layout: TABLE_LAYOUT,
  };
}
